import React, { useState, useMemo } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import AppTableContainer from "@crema/core/AppTableContainer";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";
import { TransactionMasterData } from "types/models/transactionMaster/TransactionMasterApp";

interface TransactionTableProps {
  transaction: TransactionMasterData[];
}

const TransactionTable: React.FC<TransactionTableProps> = ({ transaction }) => {
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof TransactionMasterData>("FirstName");

  const handleSort = (property: keyof TransactionMasterData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedTransaction = useMemo(() => {
    return [...transaction].sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue == null || bValue == null) return 0;

      if (typeof aValue === "string" && typeof bValue === "string") {
        return aValue.localeCompare(bValue) * (order === "asc" ? 1 : -1);
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return (aValue - bValue) * (order === "asc" ? 1 : -1);
      }

      return 0;
    });
  }, [transaction, order, orderBy]);

  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading order={order} orderBy={orderBy} onSort={handleSort} />
        </TableHead>
        <TableBody>
          {sortedTransaction.map((data) => (
            <TableItem data={data} key={data.id} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default TransactionTable;
